// src/hooks/useAuthRedirect.js

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AI_ENABLED } from "../config/constants";

/**
 * useAuthRedirect
 * Centralizes the logic for where a user should go after authentication.
 */
export const useAuthRedirect = () => {
  const navigate = useNavigate();

  /**
   * @param {object} userData - The user data object.
   * @param {('register'|'login'|null)} [authAction=null] - Overrides default flow.
   */
  const redirectAuthenticatedUser = useCallback((userData, authAction = null) => {
    
    // --- 1. HANDLE ACTION OVERRIDES (NEW REQUIREMENTS) ---
    if (authAction === 'register') {
      // New Users (Sign-up) go directly to the Membership Customization page.
      console.log("Redirecting new user to /membership.");
      navigate("/membership", { replace: true });
      return;
    }

    if (authAction === 'login') {
      // Returning Users (Login) go directly to the Store.
      console.log("Redirecting returning user to /ijrr-gear.");
      navigate("/ijrr-gear", { replace: true });
      return;
    }
    // --- END ACTION OVERRIDES ---
    
    // --- 2. STANDARD AI/PROFILER FLOW (Fallback for other auth events) ---
    console.log("Redirecting user based on AI Status & Profile:", {
      aiEnabled: AI_ENABLED,
      profileCompleted: userData?.profile_completed_at
    });

    // 1. If AI is DISABLED, we treat it as a standard shop.
    if (!AI_ENABLED) {
      navigate("/ijrr-gear", { replace: true });
      return;
    }

    // 2. If AI is ENABLED, we check the profile status.
    if (userData?.profile_completed_at) {
      // Profile is done -> Go to Shop (IJRR Gear)
      navigate("/ijrr-gear", { replace: true });
    } else {
      // Profile needs setup -> Go to Pirate Profiler (Wizard)
      navigate("/pirate-profiler", { replace: true });
    }
  }, [navigate]);

  return { redirectAuthenticatedUser };
};